export default __webpack_public_path__ + "static/Futura-Medium-0b9c50b124bc37756897ff1cab256bff.woff2";